import { InventorySnapshot } from '@/services/dtos/accessRequest.dto';
import { Calendar, CalendarDays } from 'lucide-react';
import {
    ACCESS_SECTION_MESSAGES,
    PLAN_SOURCE_LABEL,
} from './access-section-messages';

interface InventorySnapshotSectionProps {
    snapshot: InventorySnapshot;
    planSource?: 'term_flow' | 'retaguarda_legacy';
}

export function InventorySnapshotSection({
    snapshot,
    planSource,
}: InventorySnapshotSectionProps) {
    const formattedDate = (() => {
        try {
            return new Date(snapshot.fetchedAt).toLocaleString('pt-BR');
        } catch {
            return snapshot.fetchedAt;
        }
    })();

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2">
                <Calendar className="h-5 w-5 text-gray-500" />
                <h3 className="text-lg font-medium">
                    {ACCESS_SECTION_MESSAGES.SNAPSHOT.TITLE}
                </h3>
            </div>
            <div className="grid gap-2 text-sm">
                <div className="flex items-center gap-1.5">
                    <CalendarDays className="h-4 w-4 text-gray-500 shrink-0" />
                    <span>{formattedDate}</span>
                </div>
                <div>
                    {ACCESS_SECTION_MESSAGES.SNAPSHOT.USERS_FOUND_LABEL}
                    {snapshot.usersFound}
                </div>
                <div>
                    {ACCESS_SECTION_MESSAGES.SNAPSHOT.OPERATORS_FOUND_LABEL}
                    {snapshot.operatorsFound}
                </div>
                {planSource && (
                    <div>
                        {ACCESS_SECTION_MESSAGES.SNAPSHOT.PLAN_SOURCE_LABEL}
                        <span className="font-medium">
                            {PLAN_SOURCE_LABEL[planSource] ?? planSource}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
